var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapLocationPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "9 6 12 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15 14.5a2.5 2.5 0 1 1 .002-5.002A2.5 2.5 0 0 1 15 14.5M15 6a6 6 0 0 0-6 6q.001.34.04.67c.398 4.214 4.517 4.671 5.96 11.323 1.443-6.652 5.562-7.109 5.96-11.324q.039-.33.04-.669a6 6 0 0 0-6-6"
})));
export default SvgMapLocationPin;